import api from "./api";

// Cliente de los endpoints de stats por asistente IA (isAuth + getTenantId;
// companyId del token). Todas devuelven response.data.

// Gate de menú + flags de visibilidad de paneles. Siempre 200.
export const fetchStatsConfig = async () => {
  const { data } = await api.get("/ai-assistant-stats/config");
  return data; // { enabled, visibility:{8 flags} }
};

export const fetchAssistants = async () => {
  const { data } = await api.get("/ai-assistant-stats/assistants");
  return data; // { enabled, count, assistants:[...] }
};

export const fetchRollup = async (from, to) => {
  const { data } = await api.get("/ai-assistant-stats/rollup", {
    params: { from, to },
  });
  return data; // { range, totals, roi, perAssistant }
};

export const fetchAssistantStats = async (assistantId, params) => {
  const { data } = await api.get(
    `/ai-assistant-stats/assistant/${assistantId}`,
    { params }
  );
  return data; // bloque KPI + roi + breakdowns
};

export const fetchAssistantInsights = async (assistantId, from, to) => {
  const { data } = await api.get(
    `/ai-assistant-stats/assistant/${assistantId}/insights`,
    { params: { from, to } }
  );
  return data; // { insights:[...] }
};
